import type { ReactNode } from 'react';
import { cn } from '../cn.js';

export interface Feature {
  title: string;
  description: string;
  icon?: ReactNode;
}

export interface FeatureGridProps {
  features: Feature[];
  className?: string;
}

export function FeatureGrid({ features, className }: FeatureGridProps) {
  return (
    <section className={cn('mx-auto max-w-5xl px-6 py-16', className)}>
      <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {features.map((f) => (
          <div key={f.title} className="rounded-2xl border border-brand-sage/15 bg-card p-6 shadow-brand">
            {f.icon ? <div className="mb-3 text-primary">{f.icon}</div> : null}
            <h3 className="text-lg font-semibold">{f.title}</h3>
            <p className="mt-2 text-sm text-muted-foreground">{f.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
